<template>
  <div class="wrapper">
    <div class="form-group">
      <div class="label-wrap">请求地址：</div>
      <div class="form-item-wrap">
        <span class="text-blue">http://api.xxx.com/api/xxx</span>
      </div>
    </div>

    <div class="form-group">
      <div class="label-wrap">请求方法：</div>
      <div class="form-item-wrap">
        POST
      </div>
    </div>

    <div class="form-group table-content">
      <div class="label-wrap table-title">公共参数:</div>
      <div class="form-item-wrap">
        <Table border
               :columns="columns1"
               :data="data1">
          <template slot-scope="{ row, index }"
                    slot="isMust">
            <span class="status-text-success"
                  v-if="row.isMust == 1">是</span>
            <span class="status-text-reject"
                  v-else>否</span>
          </template>
        </Table>
      </div>
    </div>
    <div class="form-group table-content">
      <div class="label-wrap table-title">请求参数:</div>
      <div class="form-item-wrap">
        <Table border
               :columns="columns1"
               :data="data1">
          <template slot-scope="{ row, index }"
                    slot="isMust">
            <span class="status-text-success"
                  v-if="row.isMust == 1">是</span>
            <span class="status-text-reject"
                  v-else>否</span>
          </template>
        </Table>
      </div>
    </div>

    <div class="form-group table-content">
      <div class="label-wrap table-title">响应示例:</div>
      <div class="form-item-wrap border-gray">
        <json-viewer :value="jsonData"></json-viewer>
      </div>
    </div>

    <div class="form-group table-content">
      <div class="label-wrap table-title">响应参数说明:</div>
      <div class="form-item-wrap">
        <Table border
               :columns="columns2"
               :data="data1">
          <template slot-scope="{ row, index }"
                    slot="isMust">
            <span class="status-text-success"
                  v-if="row.isMust == 1">是</span>
            <span class="status-text-reject"
                  v-else>否</span>
          </template>
        </Table>
      </div>
    </div>
    <div class="form-group table-content">
      <div class="label-wrap table-title">错误码:</div>
      <div class="form-item-wrap">
        <Table border
               :columns="columns3"
               :data="data3">
          <template slot-scope="{ row, index }"
                    slot="isMust">
            <span class="status-text-success"
                  v-if="row.isMust == 1">是</span>
            <span class="status-text-reject"
                  v-else>否</span>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>
<script>
import { Table } from 'view-design'

export default {
  name: 'DocumentDesc',
  components: {
    Table
  },
  data: function () {
    return {
      columns1: [
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '类型',
          key: 'type'
        },
        {
          title: '是否必须',
          key: 'isMust',
          slot: 'isMust',
        },
        {
          title: '说明',
          key: 'desc'
        }
      ],
      data1: [
        {
          name: 'appkey',
          type: 'String',
          isMust: '1',
          desc: '2016-10-03'
        },
        {
          name: 'Jim Green',
          type: 'String',
          isMust: '0',
          desc: '2016-10-01'
        },
        {
          name: 'Joe Black',
          type: 'String',
          isMust: '0',
          desc: '2016-10-02'
        },
        {
          name: 'Jon Snow',
          type: 'String',
          isMust: '1',
          desc: '2016-10-04'
        }
      ],
      jsonData: {
        total: 25,
        limit: 10,
        skip: 0,
        links: {
          previous: undefined,
          next: function () { },
        }
      },
      columns2: [
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '类型',
          key: 'type'
        },
        {
          title: '说明',
          key: 'desc'
        }
      ],
      columns3: [
        {
          title: '名称',
          key: 'code'
        },
        {
          title: '错误消息',
          key: 'msg'
        },
        {
          title: '解决方案',
          key: 'resolve'
        }
      ],
      data3: [
        {
          code: '1002',
          msg: 'token过期',
          resolve: '重新登陆获取token',
        },
        {
          code: '1003',
          msg: 'appkey无效',
          resolve: '请到”我的应用“获取正确的appkey'
        }
      ]
    }
  }
}
</script>
<style scoped>
.text-blue {
  color: #00b5e3;
}
.status-text-success {
  font-size: 14px;
  color: #3d9efc;
}
.status-text-reject {
  font-size: 14px;
  color: #ff8622;
}
.border-gray {
  border: 1px solid #dcdee2;
  border-radius: 2px;
}
.wrapper .form-group {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.8rem;
  width: 100%;
  min-width: 0;
  align-content: center;
}
.wrapper .form-group .label-wrap {
  font-size: 14px;
  color: #666666;
  width: 1.5rem;
  margin-right: 0.4rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.wrapper .form-group .form-item-wrap {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.wrapper .form-group.table-content {
  display: block;
}
.wrapper .form-group .label-wrap.table-title {
  width: 100%;
  font-weight: bold;
  margin-bottom: 0.4rem;
  font-size: 15px;
}
>>> .ivu-table-wrapper-with-border {
  border: 1px solid #dcdee2;
  border-bottom: 0;
  border-right: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/document/api/desc/Index.vue